import { z } from 'zod';
import { TaskView } from './project.js';
/** Traversal uses immutable task numbers within the selected project. */
export const TaskPageQuery = z.object({
    cursor: z.coerce.number().int().nonnegative().max(4294967295).optional(),
    limit: z.coerce.number().int().min(1).max(500).default(200),
});
export const TaskPage = z.object({
    items: z.array(TaskView),
    nextCursor: z.number().int().positive().nullable(),
});
//# sourceMappingURL=task-page.js.map